import { connect } from 'react-redux'
import React, { useEffect, useState } from 'react'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { Fieldset } from 'primereact/fieldset'
import {
  Btn,
  Cnpj,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { getVeiculos } from '../../../../services/api/https/registration/veiculo.http'
import { errorHandler } from '../../../../services/util/error.service'
import { assocPlacasPrevistaComEntregas } from '../../../../services/api/https/deliveries/roteirizacao-previa.http'

const LOAD_MESSAGE = {
  NONE: 'NONE',
}

const INITIAL_STATE = {
  entregas: [],
  vehicles: [],
  selecionarTodos: false,
  veiculoSelecionado: null,
  acaoSelecionada: {},
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

function AssociarPlacaPrevistaManualmente({
  dispatch,
  history,
  selectedTp,
  acaoSelecionada,
  entregas,
  roteirizacao,
  onUpdateComplete,
}) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    setState(prevState => ({
      ...prevState,
      acaoSelecionada: acaoSelecionada,
      entregas: [...entregas.map(e => ({ ...e, selected: false }))],
    }))
    if (acaoSelecionada.value === '004') {
      fetchInicialData(selectedTp)
    }
  }, [acaoSelecionada, entregas, selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(hideLoadingBox())
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({ ...prevState, errorMessage: null }))
    }
  }, [state.errorMessage])

  async function fetchInicialData(selectedTp) {
    await getVeiculos(selectedTp)
      .then(veiculos => setState(prevState => ({ ...prevState, vehicles: veiculos })))
      .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
  }

  const onBtnSalvar = entregas => {
    dispatch(showLoadingBox('Aguarde...', 'Associando placas previstas'))
    const entregasWithNewBadge = entregas.filter(e => e.placa_prevista_carregamento_nova)
    if (entregasWithNewBadge.length) {
      const dataBuilded = entregasWithNewBadge.map(e => ({
        identificador: e.identifier,
        vehicle_badge: e.placa_prevista_carregamento_nova,
      }))
      assocPlacasPrevistaComEntregas(roteirizacao.id, dataBuilded)
        .then(entregasUpdated => {
          onUpdateComplete(entregasUpdated)
          dispatch(hideLoadingBox())
          dispatch(showMessageBox('Placas associadas com sucesso', null))
        })
        .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
    } else {
      setState(prevState => ({
        ...prevState,
        errorMessage: 'Associe novas placas previstas antes de tentar salvar',
      }))
    }
  }

  const onBtnCarregar = (veiculoSelecionado, entregas) => {
    if (!veiculoSelecionado) {
      setState(prevState => ({
        ...prevState,
        errorMessage: 'Selecione um veiculo para associar a placa',
      }))
    } else {
      entregas.forEach(e => {
        if (e.selected) {
          e.placa_prevista_carregamento_nova = veiculoSelecionado.vehicle_badge
        }
      })
      setState(prevState => ({ ...prevState, entregas: entregas }))
    }
  }

  const onCheckboxClicked = entrega => {
    setState(prevState => {
      const index = prevState.entregas.findIndex(e => e.identifier === entrega.identifier)
      if (index !== -1) {
        prevState.entregas[index].selected = !entrega.selected
      }
      return { ...prevState }
    })
  }

  const onSelecionarTodos = (selecionarTodos, entregas) => {
    setState(prevState => {
      prevState.selecionarTodos = !selecionarTodos
      prevState.entregas = [...entregas.map(e => ({ ...e, selected: !selecionarTodos }))]
      return { ...prevState }
    })
  }

  return (
    <div style={{ display: state.acaoSelecionada.value !== '004' ? 'none' : 'block' }}>
      <Fieldset legend="Associação de Placas Previstas - Manual">
        <div className="p-grid p-align-center">
          <div className="p-col-fixed" style={{ paddingTop: 23 }}>
            <CustomCheckbox
              checked={state.selecionarTodos}
              onChange={() => onSelecionarTodos(state.selecionarTodos, state.entregas)}
            >
              Selecionar Todos
            </CustomCheckbox>
          </div>
          <div className="p-col-2" style={{ paddingTop: 23 }}>
            <CustomDropdown
              showLabel={true}
              label="Veiculos"
              marginTop={0}
              optionLabel="vehicle_badge"
              options={state.vehicles}
              value={state.veiculoSelecionado}
              filter={true}
              onChange={veiculoSelecionado =>
                setState(prevState => ({ ...prevState, veiculoSelecionado: veiculoSelecionado }))
              }
            />
          </div>
          <div className="p-col-fixed" style={{ paddingTop: 40 }}>
            <div style={{ display: 'inline-block', marginLeft: 15 }}>
              <Btn onClick={() => onBtnCarregar(state.veiculoSelecionado, state.entregas)}>
                Definir Placa
              </Btn>
            </div>
          </div>
          <div className="p-col-3" style={{ paddingTop: 40 }}>
            <div style={{ display: 'inline-block', marginLeft: 15 }}>
              <Btn onClick={() => onBtnSalvar(state.entregas)}>Salvar</Btn>
            </div>
          </div>
          <div className="p-col-12" style={{ marginTop: 20 }}>
            <DataTable
              value={state.entregas}
              header={
                <CustomDataTableHeader
                  onChange={value => setState(prevState => ({ ...prevState, globalFilter: value }))}
                />
              }
              globalFilter={state.globalFilter}
              emptyMessage="Não existe veículos para serem enviados para rota"
              paginator={true}
              rows={10}
            >
              <Column
                field="selected"
                style={tableCellCentered(60)}
                body={entrega => (
                  <CustomCheckbox
                    checked={entrega.selected}
                    onChange={() => onCheckboxClicked(entrega)}
                  />
                )}
              />
              <Column field="identifier" header="Identificador" />
              <Column field="nomeFantasia" header="Nome Fantasia" />
              <Column
                field="cnpj"
                header="CNPJ"
                body={({ cnpj }) => <Cnpj>{cnpj}</Cnpj>}
                style={tableCellCentered(150)}
              />
              <Column field="companyName" header="Empresa" style={tableCellCentered()} />
              <Column
                field="city_name"
                header="Cidade"
                style={tableCellCentered()}
                sortable={true}
              />
              <Column field="qteCaixas" style={tableCellCentered()} header="Qte. SKUs" />
              <Column
                field="placa_prevista_carregamento"
                header="Placa Prevista"
                style={tableCellCentered()}
                body={entrega => {
                  return entrega && entrega.placa_prevista_carregamento_nova ? (
                    <span style={{ color: 'red' }}>{entrega.placa_prevista_carregamento_nova}</span>
                  ) : (
                    <span style={{ color: 'green' }}>{entrega.placa_prevista_carregamento}</span>
                  )
                }}
              />
            </DataTable>
          </div>
        </div>
      </Fieldset>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(AssociarPlacaPrevistaManualmente)
